import { render } from "./StudentUser.vue?vue&type=template&id=53640e08&scoped=true"
import script from "./StudentUser.vue?vue&type=script&lang=js"
export * from "./StudentUser.vue?vue&type=script&lang=js"

import "./StudentUser.vue?vue&type=style&index=0&id=53640e08&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53640e08"]])

export default __exports__